import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideLottieOptions } from 'ngx-lottie';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { petPetsTheme } from '../theme/custom-theme';
import { routes } from './app.routes';
import { tokenInterceptor } from './config/auth/token.interceptor';
import { requestTrackerInterceptor } from './config/monitoring/request-tracker.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideHttpClient(
      withInterceptors([
        requestTrackerInterceptor,
        tokenInterceptor
      ]),
    ),
    providePrimeNG({
      theme: {
        preset: petPetsTheme,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, utilities, primeng'
          },
          darkModeSelector: '.dark'
        }
      }
    }),
    provideLottieOptions({
      player: () => import('lottie-web')
    }),
    provideAnimationsAsync(),
    provideRouter(routes, withComponentInputBinding()),
    provideZoneChangeDetection({ eventCoalescing: true })
  ]
};
